var exports = {
  "kL": "DMSidebarSkeleton.module__container___VEkyc0",
  "Kd": "DMSidebarSkeleton.module__containerMobile___VEkyc0",
  "wx": "DMSidebarSkeleton.module__header___VEkyc0",
  "Od": "DMSidebarSkeleton.module__mobileHeader___VEkyc0",
  "Fy": "DMSidebarSkeleton.module__mobileHeaderActions___VEkyc0",
  "P1": "DMSidebarSkeleton.module__scrollArea___VEkyc0",
  "Qs": "DMSidebarSkeleton.module__content___VEkyc0",
  "wh": "DMSidebarSkeleton.module__mobileContent___VEkyc0",
  "jH": "DMSidebarSkeleton.module__spacer___VEkyc0",
  "nM": "DMSidebarSkeleton.module__row___VEkyc0",
  "TZ": "DMSidebarSkeleton.module__mobileRow___VEkyc0",
  "u4": "DMSidebarSkeleton.module__rowContent___VEkyc0",
  "yW": "DMSidebarSkeleton.module__channelInfo___VEkyc0",
  "jn": "DMSidebarSkeleton.module__channelNameRow___VEkyc0",
  "$s": "DMSidebarSkeleton.module__channelSubtextRow___VEkyc0",
  "me": "DMSidebarSkeleton.module__separator___VEkyc0",
  "bV": "DMSidebarSkeleton.module__sectionHeader___VEkyc0",
  "o5": "DMSidebarSkeleton.module__channelList___VEkyc0",
  "US": "DMSidebarSkeleton.module__bottomSpacer___VEkyc0",
  "cB": "DMSidebarSkeleton.module__mobileFab___VEkyc0",
};

module.exports = exports;
